/* eslint-disable @typescript-eslint/no-explicit-any */
export const getSize = (attributes: any, key: string) => {
  const data = attributes?.reduce((acc: any, curr: any) => {
    //alert(curr.GlobalAttributeDefaultValueId);
    if (curr.AttributeCode === key && curr.GlobalAttributeDefaultValueId != null) {
      const result = {
        value: curr?.AttributeDefaultValue,
        label: curr?.AttributeDefaultValue,
      };

      acc.push(result);
    }
    return acc;
  }, []);
  return data;
};
